export var MAX_ATTACHMENTS = 5;

export function normalizeAttachmentBounds(currentMin, currentMax, field, value) {
  if (value !== null && value > MAX_ATTACHMENTS) {
    value = MAX_ATTACHMENTS;
  }

  var result = {};
  result[field] = value;

  if (field === 'min') {
    if (currentMax !== null && value > currentMax) {
      result.max = Math.min(value, MAX_ATTACHMENTS);
    } else if (currentMax === null && value > 0) {
      result.max = Math.min(value, MAX_ATTACHMENTS);
    }
  } else if (field === 'max') {
    if (value !== null && value < currentMin) {
      result.max = currentMin;
    }
  }

  return result;
}

export function buildTypeCodeMap(accreditationDefinitions) {
  var map = {};
  for (var i = 0; i < accreditationDefinitions.length; i++) {
    map[accreditationDefinitions[i].typeCode] = accreditationDefinitions[i];
  }
  return map;
}
